<div *ngIf="!projects?.length; else table">
    {{noDataMessage}}
</div>

<ng-template #drawerContent>
    <syn-project-bulk-edit
        [projects]="selection.selected"
        (close)="closeDrawer()"
        (updated)="refreshProjects()"/>
</ng-template>

<ng-template #table>
    <mat-card-title class="message">{{ message }}</mat-card-title>
    <mat-card appearance="outlined" class="card-data-table">
            <syn-filter-bar
                searchPlaceholder="Rechercher un projet"
                [showToggle]="true"
                toggleLabel="Afficher les projets UNPROVISIONED ou CLOSED"
                (filterChange)="applyFilter($event.searchFilter, $event.input)"
                (toggleChange)="onToggleChange($event)">

                @if (edit) {
                    <div fxLayout="row" fxLayoutAlign="end center" class="table-actions">
                        @if (hasReachedBulkProjectUpdateLimit) {
                            <button mat-stroked-button [disabled]="true" aria-label="Bulk edit">
                                <mat-icon svgIcon="note-edit-outline"></mat-icon>
                                Limite de {{ maxBulkEditProjectLimit }} dépassée
                            </button>
                        } @else {
                            <button mat-stroked-button [disabled]="!selection.selected.length"
                                (click)="openDrawer()" aria-label="Bulk edit">
                                <mat-icon svgIcon="note-edit-outline"></mat-icon>
                                Édition groupée
                            </button>
                        }
                    </div>
                }
            </syn-filter-bar>

            <mat-table #table [dataSource]="dataSource" matSort>

                <!-- Selection -->
                <ng-container matColumnDef="select">
                    <mat-header-cell *matHeaderCellDef fxFlex="10">
                        <div fxLayout="row" fxLayoutAlign="start center">
                            <mat-checkbox *ngIf="edit" color="primary"
                                (change)="$event ? masterToggle() : null"
                                [checked]="selection.hasValue() && isAllSelected()"
                                [indeterminate]="selection.hasValue() && !isAllSelected()">
                            </mat-checkbox>
                            <p class="total">{{ selection.selected.length > 0 ? selection.selected.length : '' }}</p>
                        </div>
                    </mat-header-cell>
                    <mat-cell *matCellDef="let row" fxFlex="10">
                        <mat-checkbox color="primary"
                                      (click)="$event.stopPropagation()"
                                      (change)="toggleCheckbox($event, row)"
                                      [checked]="selection.isSelected(row)">
                        </mat-checkbox>
                    </mat-cell>
                </ng-container>

                <!-- id -->
                <ng-container matColumnDef="id">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> ID </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        <syn-project-avatar [project]="row" [showId]="true" [size]="24"></syn-project-avatar>
                    </mat-cell>
                </ng-container>

                <!-- name -->
                <ng-container matColumnDef="name">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Projet </mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{row.name}} </mat-cell>
                </ng-container>

                <!-- status -->
                <ng-container matColumnDef="user-role">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Role de l'utilisateur </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        <span class="syn-inline-list">
                            <span *ngIf="row.deliveryManager === user?.id">
                                Delivery Manager
                            </span>
                            <span *ngIf="row.backupDeliveryManager === user?.id">
                                Backup du Delivery Manager
                            </span>
                            <span *ngIf="row.buildProjectManager === user?.id">
                                Build Project Manager
                            </span>
                            <span *ngIf="user?.id | inArray: row.appManagers">
                                App Manager
                            </span>
                        </span>
                    </mat-cell>
                </ng-container>

                <!-- status -->
                <ng-container matColumnDef="status">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Statut </mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{row.status}} </mat-cell>
                </ng-container>

                <!-- businessCode -->
                <ng-container matColumnDef="business-code">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Code Affaire / BPJ </mat-header-cell>
                    <mat-cell *matCellDef="let row"> {{row.businessCode}} </mat-cell>
                </ng-container>

                <!-- name -->
                <ng-container matColumnDef="groups">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Groupes </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        <mat-chip-listbox>
                            <mat-chip disableRipple disabled class="readonly-chip" *ngFor="let tag of row.groups">{{tag}}</mat-chip>
                        </mat-chip-listbox>
                    </mat-cell>
                </ng-container>

                <!-- name -->
                <ng-container matColumnDef="tags">
                    <mat-header-cell *matHeaderCellDef mat-sort-header> Tags </mat-header-cell>
                    <mat-cell *matCellDef="let row">
                        <mat-chip-listbox>
                            <mat-chip disableRipple disabled class="readonly-chip" *ngFor="let tag of row.tags">{{tag}}</mat-chip>
                        </mat-chip-listbox>
                    </mat-cell>
                </ng-container>

                <mat-header-row *matHeaderRowDef="columnDisplayed"></mat-header-row>
                <mat-row *matRowDef="let row; columns: columnDisplayed;"></mat-row>
            </mat-table>

            <mat-paginator *ngIf="showPaginator" #paginator [pageSizeOptions]="pageSizeOptions" [pageSize]="pageSize"></mat-paginator>
    </mat-card>

</ng-template>
